import React from 'react';
import { Redirect } from 'expo-router';

// Expo Router requires a base route even when a platform override supplies
// the screen. Local OpenCode Work is available through the Mac override.
export default function LocalWorkFallback() {
  return <Redirect href="/app" />;
}
